var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(-27.555 -10.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(27.555 10.336)",
    fill: "#fff",
    stroke: "#ddd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7570",
    "data-name": "Path 7570",
    d: "M2.643-10.443.264-11.13l.429-1.318,2.356.913-.117-2.683h1.4l-.117,2.73,2.317-.9.421,1.342-2.418.686,1.56,2.075L4.96-7.455,3.556-9.7,2.167-7.526l-1.139-.8Zm8.657,0L8.921-11.13l.429-1.318,2.356.913-.117-2.683h1.4l-.117,2.73,2.317-.9.421,1.342-2.418.686,1.56,2.075-1.131.827L12.213-9.7,10.824-7.526l-1.139-.8Zm8.657,0-2.379-.686.429-1.318,2.356.913-.117-2.683h1.4l-.117,2.73,2.317-.9.421,1.342-2.418.686,1.56,2.075-1.131.827L20.87-9.7,19.482-7.526l-1.139-.8Z",
    transform: "translate(47.291 53.555)",
    fill: "#474b4f",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon_password.ccd76ee657304b9e355d563b3a64f8de.svg";
export { ForwardRef as ReactComponent };